import React, { useEffect, useState } from 'react';

import { AttendanceHeader } from './AttendanceHeader';
import { AttendanceSummary } from './AttendanceSummary';
import { AttendanceTable } from './AttendanceTable';
import { BulkActions } from './BulkActions';
import { useDispatch, useSelector } from 'react-redux';
import { StudentsList } from '../../features/attendance/AttendanceSlice';
import { Snackbar, Alert } from '@mui/material';
import { showAlert } from '../UIElements/AlertService';

function AttendancePage({ setIsChanged }) {
  let { attendanceData } = useSelector((state) => state.attendance);
  const dispatch = useDispatch();
  const [searchValues, setSearchValues] = useState({
    departmentName: attendanceData?.departmentName || '',
    className: attendanceData?.className || '',
    sectionName: attendanceData?.sectionName || '',
    attendanceDate: attendanceData?.attendanceDate || '',
  });
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const [isError, setIsError] = useState(false); //variable to let know error if students List not retrived properly brother
  const [students, setStudents] = useState([]); //to store the students
  const [initialData, setInitialData] = useState([]);
  const [submitted, setSubmitted] = useState(false); //to know weather date is submitted date or an new one
  const [absentCount, setAbsentCount] = useState(0);
  const [hasChanges, setHasChanges] = useState(false); //to know any modifiactions in the page
  const [loading, setLoading] = useState(false);
  async function getStudents(searchValues) {
    try {
      let response;
      if (
        searchValues.attendanceDate === attendanceData?.attendanceDate &&
        searchValues.departmentName === attendanceData?.departmentName &&
        searchValues.className === attendanceData?.className&&
        ((searchValues?.sectionName) ? searchValues.sectionName=== attendanceData?.sectionName:true)
      )
       {
        response = { data: attendanceData, status: 200 };
      } else {
        setLoading(true);
        setHasChanges(false);
        response = await dispatch(
          StudentsList({ ...searchValues, instituteType: instituteType }),
        ).unwrap();
      }
      if (response?.status !== 200 || response?.status === 409) {
        if (response?.status === 409)
          showAlert(
            'Selected date is not in between academic year start-date and end-date. Please add <b>Academic Year.</b>',
          );
        setIsError(true);
        setStudents([]);
        setLoading(false);
      } else {
        let absentsList = response?.data?.absenties?.reduce(
          (acc, { studentId, remarks }) => {
            acc[studentId] = remarks;
            return acc;
          },
          {},
        );
        let students = [];
        let count = 0;
        try {
          for (let student of response.data.students) {
            //Combining the students and absenties KList
            if (Object.keys(absentsList).includes(student.studentId)) {
              students.push({
                studentId: student.studentId,
                rollNumber: student.rollNumber,
                name: student.name,
                status: 'absent',
                remarks: absentsList[student.studentId],
              });
            } else {
              if (response.data.submit) {
                students.push({
                  studentId: student.studentId,
                  rollNumber: student.rollNumber,
                  name: student.name,
                  status: 'present',
                  remarks: '',
                });
              } else {
                students.push({
                  studentId: student.studentId,
                  rollNumber: student.rollNumber,
                  name: student.name,
                  status: '',
                  remarks: '',
                });
              }
            }
          }
        } catch (error) {
          console.log('No Students  Present');
        }

        for (let obj of students) {
          if (obj.status == 'absent') {
            count += 1;
          }
        }
        setAbsentCount(count);
        setStudents(students);
        setInitialData(students);
        setSubmitted(response?.data?.submit);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  }
  function markAllPresent() {
    const newList = students.map((obj) => ({
      ...obj,
      status: 'present',
      remarks: '',
    }));
    setStudents(newList);
    setAbsentCount(0);
    newList.length > 0 ? setHasChanges(true) : '';
  }

  function markAllAbsent() {
    const newList = students.map((obj) => ({ ...obj, status: 'absent' }));
    setStudents(newList);
    setAbsentCount(newList.length);
    newList.length > 0 ? setHasChanges(true) : '';
  }
  useEffect(() => {
    setIsChanged(hasChanges);
  }, [hasChanges]);

  useEffect(() => {
    if (
      searchValues?.departmentName &&
      searchValues?.className &&
      searchValues?.attendanceDate&&
      ((searchValues?.sectionName) ? searchValues.sectionName:true)
    ) {
      getStudents(searchValues);
    }
  }, [searchValues]);

  return (
    <>
      <div className='md:pl-6'>
        <Snackbar
          open={isError}
          onClose={() => setIsError(false)}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            severity='error'
            variant='filled'
            onClose={() => setIsError(false)}
            sx={{ width: '100%' }}
          >
            Error in Getting Students List . {'  '}{' '}
            <pre className='hidden sm:inline '> </pre>
          </Alert>
        </Snackbar>
        <AttendanceHeader
          Loading={loading}
          searchValues={searchValues}
          setSearchValues={setSearchValues}
          submitted={submitted}
          hasChanges={hasChanges}
          setHasChanges={setHasChanges}
          students={students}
        />
        <div className='text-left flex gap-2 p-0 lg:*:w-[330px]  '>
          <BulkActions
            students={students}
            markAllPresent={markAllPresent}
            markAllAbsent={markAllAbsent}
          />
          {submitted && (
            <AttendanceSummary absent={absentCount} students={students} />
          )}
        </div>

        <div>
          <AttendanceTable
            Students={students}
            setStudents={setStudents}
            loading={loading}
            initialData={initialData}
            setInitialData={setInitialData}
            absentCount={absentCount}
            setAbsentCount={setAbsentCount}
            searchValues={searchValues}
            setSearchValues={setSearchValues}
            submitted={submitted}
            hasChanges={hasChanges}
            setHasChanges={setHasChanges}
            setSubmitted={setSubmitted}
          />
        </div>
      </div>
    </>
  );
}

export default React.memo(AttendancePage);
